<mat-icon
  [style]="{ color: isValid ? '#4caf50' : '#f44336' }">
    {{isValid ? 'check_circle_outline' : 'error_outline'}}
</mat-icon>